export const PropertiesEndpoint = {
  getProperties: `/admin/propertiesAll?`,
  modifyStatus: `/admin/disableProperty?propertyId=`,
  addProperty: `/admin/listProperty`,
  editProperty: `/admin/Updateproperty`,
  addPlot: `/admin/list-plots`,
  editPlot: `/admin/update-plot`,
  deleteProperty: `/admin/deleteProperty?propertyId=`,
  deleteImageAPI: `/admin/deleteImages?imageId=`,
  uploadImageAPI: `/admin/editImage?imageId=`,
  uploadfloorPlanImageAPI: `/admin/edit-image-floorPlan`,
  uploadThumbnailAPI: `/admin/addThumbNail?imageId=`,
  getPropertiesbyId: `/admin/getProperty?propertyId=`,
  getPropertTypeUpdate: `/admin/update-property-type`,
  getPropertyTypeDetails: `/admin/get-property-type`,
  //Property type endpoint
  getPropertyType: `/admin/get-property-type`,
  updatePropertyType: `/admin/update-property-type`,
  addPropertyType: `/admin/create-property-type`,
  deletePropertyType: `/admin/delete-property-type`,
};
